module.exports = __webpack_public_path__ + "media/public/img/landing_page/headout-logo-78b3af51c9f4a18b49b0222b78ce6b12.png";